import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PolicyService} from '../../../../../policy/services/policy.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {AnimationOptions} from 'ngx-lottie';
import {CalcPremDiffCollation, Collation, Policy, PolicyBenefitsAdded} from '../../../../models/policy.model';
import {GlobalQuestionService} from '../../../../services/global-question.service';
import {EntryType} from '../../../../constants';
import { Alert } from 'src/app/modules/shared/utilities';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { StorageService } from '../../../../services/storage.service';

declare var $: any;
declare var accounting: any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-pause-policy',
    templateUrl: './pause-policy.component.html',
    styleUrls: ['./pause-policy.component.scss'],
    standalone: false
})
export class PausePolicyComponent implements OnInit, OnChanges {

  @Input() policy: Policy;
  @Input() item: Collation;
  @Input() vap: PolicyBenefitsAdded;
  @Input() frequency_id = 3;
  @Input() entity = '';
  @Input() source = '';
  @Input() isEditPolicyPage = false;
  @Input() new_session_id: any;
  @Output() getNewData = new EventEmitter<boolean>();

  days = 0;
  dateFormat = 'dd MMM yyyy';
  spinner = false;
  accounting: any;
  buttonEnabled = false;
  pauseButtonEnabled = false;
  startDate: any;
  endDate: any;
  startFullDate: Date;
  endFullDate: Date;
  entities = Entity;
  agreeChecked = false;
  refund: CalcPremDiffCollation;
  startMinDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  endMaxDate: any;
  options: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  dates: any;

  constructor(
    private policyService: PolicyService,
    public questionService: GlobalQuestionService,
    public datePipe: DatePipe,
    private policyQuery: PolicyQuery,
    public router: Router,
    private storageService: StorageService) {
  }

  ngOnInit(): void {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.policy?.currentValue !== changes?.policy?.previousValue) {
      this.policy = changes?.policy?.currentValue;
    }
    if (changes?.frequency_id?.currentValue !== changes?.frequency_id?.previousValue) {
      this.frequency_id = changes?.frequency_id?.currentValue;
    }
  }

  showModal(entity: Entity, item?: any): void {
    this.entity = entity;
    
    if (item) {
      if (entity === Entity.Item) {
        this.item = item;
      } else if (entity === Entity.Vap) {
        this.vap = item;
      }
    }
    let session_id = '';
    if (entity === Entity.Policy){
      if (!this.policy){
        const policy = this.policyQuery.getActive();
        let tempPolicy: Policy;
        if (Array.isArray(policy)) {
          tempPolicy = Object.assign({}, policy[0]);
        } else {
          tempPolicy = Object.assign({}, policy);
        }
        this.policy = tempPolicy;
        session_id = this.policy?.session_id;
      }
      
    }
    else{
      session_id = item?.session_id
    }
    
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    parameters.set('class_id', item?.class_id.toString());
    parameters.set('item_id', item?.session_item_id.toString());
    this.questionService.runCommandNew(`getPauseDateRange`, parameters, false)
      .subscribe(result => {
          this.dates = result[0];
          console.log(this.dates)
          this.startMinDate = result[0]?.min_date;
          this.endMaxDate = result[0]?.max_date;
          let endDate = new Date(this.dates?.default_date);
          let end =  endDate.setDate(endDate.getDate() + this.dates?.min_days) ;
          this.endDate = this.datePipe.transform( new Date(end),'yyyy-MM-dd');
          console.log(this.endDate)
          $('#pause-policy-alert-modal').modal('show');
      })
    
  }
  setStartDate(event: any): void {
    this.startDate = event;
    const d = new Date(event);
    if (!event || isNaN(d.getTime())) return;
    let max = d.setDate(d.getDate() + this.dates?.max_days) ;
     this.endDate = this.datePipe.transform( new Date(max),'yyyy-MM-dd');
     if (new Date(this.endDate) > new Date(this.dates?.max_date)){
      this.endDate = this.datePipe.transform( new Date(this.dates?.max_date),'yyyy-MM-dd')
     }
  }
  setEndDate(event: any): void {
    this.buttonEnabled = true;
    if (new Date(event) < new Date(this.startDate)){
      Alert("End date cannot be less than start date");
      this.buttonEnabled = false;
    }else{
      this.endDate = event;
    }
    if (this.startDate && this.endDate) {
      this.startFullDate = new Date(this.startDate);
      this.endFullDate = new Date(this.endDate);
      this.buttonEnabled = true;
    } else {
      this.buttonEnabled = false;
    }
  }
  onDateChanged(event: any): void {
    console.log(event);
    let d = new Date(event.start);
    let end = d.setDate(d.getDate() + 31);
    //console.log(this.datePipe.transform(end,'dd/MM/yyyy'))
    this.dates.max_date = this.datePipe.transform(end,'yyyy-MM-dd');
    if (event) {
      this.startDate = event?.start;
      this.endDate = event?.end;
      if (this.startDate && this.endDate) {
        this.startFullDate = new Date(this.startDate);
        this.endFullDate = new Date(this.endDate);
        this.buttonEnabled = true;
      } else {
        this.buttonEnabled = false;
      }
    } else {
      if (!this.startDate && !this.endDate) {
        this.buttonEnabled = false;
      }
    }
  }

  onAgreeChecked(): void {
    this.pauseButtonEnabled = this.agreeChecked;
  }

  populateProperties(): void {
    this.questionService.spinner(true);
    if (!this.frequency_id) this.frequency_id = 3;
    switch (this.entity) {
      case Entity.Policy:
        this.policyService.savePolicyUpdate(this.policy?.session_id, 2, 0, '0', this.startDate, this.endDate)
          .subscribe(response => {
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $('#pause-policy-alert-modal').modal('hide');
              $('#pause-policy-alert-modal').on('hidden.bs.modal', () => {
                $('#pause-summary-modal').modal('show');
              });
              this.questionService.spinner(false);
            },
            err => {
              this.questionService.spinner(false);
            });
        break;
      case Entity.Item:
        let item_id = this.item?.session_item_id || this.item?.item_id;
        this.policyService.savePolicyUpdate(this.policy?.session_id, 2, this.item?.class_id, item_id, this.startDate, this.endDate)
          .subscribe(response => {
            
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $('#pause-policy-alert-modal').modal('hide');
              $('#pause-policy-alert-modal').on('hidden.bs.modal', () => {
                $('#pause-summary-modal').modal('show');
              });
              this.questionService.spinner(false);
            },
            err => {
              this.questionService.spinner(false);
            });
        break;
      case Entity.Vap:
        this.policyService.savePolicyUpdate(this.policy?.session_id, 2, this.vap?.class_id, this.vap?.session_item_id, this.startDate, this.endDate, this.vap?.vaps_id)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            this.questionService.spinner(false);
            $('#pause-policy-alert-modal').modal('hide');
            $('#pause-policy-alert-modal').on('hidden.bs.modal', () => {
              $('#pause-summary-modal').modal('show');
            });
          }, err => {
            this.questionService.spinner(false);
          });
        break;
    }
  }

  closePausePolicyAlertModal(): void {
    $('#pause-policy-alert-modal').modal('hide');
  }

  closePauseSummaryModal(): void {
    $('#pause-summary-modal').modal('hide');
  }

  changeToPaused(): void {
    if (this.entity === Entity.Item || this.entity === Entity.Vap) {
      if (this.isEditPolicyPage) {
        this.getNewData.emit(true);
      } else {
        this.policyService.submitPolicyUpdates(this.policy?.session_id)
          .subscribe(() => {
            this.questionService.spinner(false);
            $(`#pause-summary-modal`).modal('hide');
            $('#pause-policy-alert-modal').modal('hide');
            this.getNewData.emit(true);
          }, err => {
            this.questionService.spinner(false);
          });
      }
    } else if (this.entity === Entity.Policy) {
      this.policyService.submitPolicyUpdates(this.policy?.session_id)
        .subscribe(() => {
          this.questionService.spinner(false);
          $(`#pause-summary-modal`).modal('hide');
          $('#pause-policy-alert-modal').modal('hide');
          this.getNewData.emit(true);
          let documentPageRoute = this.storageService.get('previous-document-page', 'flow');
          this.router.navigate([documentPageRoute]);
        }, err => {
          this.questionService.spinner(false);
        });
    }
  }

  removeAction(status_id: number): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, 0, '0', 0, status_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
                this.policyService.submitPolicyUpdates(this.policy?.session_id)
                  .subscribe(() => {
                    this.getNewData.emit(true);
                    this.questionService.spinner(false);
                  }, err => {
                    this.questionService.spinner(false);
                  });
              }, err => {
                this.questionService.spinner(false);
              });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Item) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.item?.class_id, this.item?.session_item_id, 0, status_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Vap) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.vap?.class_id, this.vap?.session_item_id, 0, status_id, this.vap?.vaps_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    }
  }

  parseJSON(obj: string): any {
    try {
      return JSON.parse(obj)[0];
    } catch (e) {
      return JSON.parse(obj);
    }
  }

}
